import React, { useEffect } from "react";
import { find } from "lodash";
import { Election } from "../types";
import Standing from "./Standing";

interface SlideProps {
  type: "welcome" | "standing" | "image" | "content";
  imgSrc?: string;
  standingName?: string;
  children?: JSX.Element;
  results?: Election[];
  registerNextSlideHandler?: (() => null) | undefined;
}
const Slide = ({
  type,
  imgSrc,
  standingName,
  children,
  results,
  registerNextSlideHandler,
}: SlideProps) => {
  const standingData = find(results, {
    name: standingName,
  });

  useEffect(() => {
    if (type != "standing" && registerNextSlideHandler) {
      registerNextSlideHandler();
    }
  }, [type]);

  let content;

  if (type == "welcome") {
    content = (
      <>
        <img alt="" src="/assets/welcome-new.jpg" loading="eager" />
        {/* <div className="onTop">
          <div className="margin-container">
            <h1 className="title">Speak Up</h1>
            <h1 className="title secondary">Cast Your Vote</h1>
            <h1 className="title">Make Change</h1>
          </div>
          <span className="hashtag">{getStyleVariable("--hashtag-text")}</span>
        </div> */}
      </>
    );
  } else if (type == "image") {
    content = (
      <>
        <img alt="" src={imgSrc} loading="eager" />
      </>
    );
  } else if (type == "standing") {
    if (standingName && standingData) {
      content = (
        <Standing
          standing={standingData}
          registerNextSlideHandler={registerNextSlideHandler}
        />
      );
    } else {
      content = <div>Standing not found</div>;
    }
  } else if (type == "content") {
    content = children;
  } else {
    content = <></>;
  }

  return <section className={`slide slide--${type}`}>{content}</section>;
};

export default Slide;
